import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
export default {
  name: 'change-bag-seal',
  components: {
    BasicSelect,
    VueElementLoading,
		Paginate
  },
  props: [],
  data() {
    return {
      isLoading: false,
      isLoadingSearch: false,
      isLoadingRack: '',
      fltracklist: [],
      BinList: [],
      racklist: [],
      fltrack: '',
      rackID: '',
      binNumber: '',
      fltrackitem: {
        value: '',
        text: ''
      },
      rackitem: {
        value: '',
        text: ''
      },
      rackItemForUpdate: {
        value: '',
        text: ''
      },
      pageCount: 0,
      pageNo: 0,
      totalRows: 0,
      limit: 10,
      createdby: '',
      userHubid: '',
      updateModal: false,
      modaldata: '',
      binNumberForUpdate:'',
      binNoErrorMsg:'',
      binNoError:false,
      rackIdErrorMsg:'',
      rackIdError:false,
      rackIdForUpdate:'',
      binError:0,
      binErrorMsg:false,
      regexForBinNum:/^[a-zA-Z0-9]{1,30}$/,
      regexFoRckId:/^[0-9]{1,30}$/,
      rackListForUpdate:[],
      rackIDForUpdate:'',
      statusmodal:false,
      modalDataForStatus:[]
    }
  },
  computed: {},
	filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.createdby = userdetail[0].email
    this.userHubid = userdetail[0].HubId[0]
    this.getRackList();
  },
  methods: {
    getRackList() {
      this.isLoadingRack = 'Loading Rack...';
      var RackListData = []
      this.input = ({});
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getRackList?hubId='+this.userHubid,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoadingRack = '';
          if (result.data.ResultCode == 100) {
            RackListData = result.data.ResponseData;
            for (var i = 0; i < RackListData.length; i++) {
              this.racklist.push({
                value: RackListData[i].rackmasterid,
                text: RackListData[i].rackname,
              })
							this.fltracklist.push({
                value: RackListData[i].rackmasterid,
                text: RackListData[i].rackname,
              })
              this.rackListForUpdate.push({
                value: RackListData[i].rackmasterid,
                text: RackListData[i].rackname,
              })
            }
          } else {
            RackListData = []
            this.racklist = []
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoadingRack = '';
          console.error(error)
        })
    },
    SelectedRackForUpdate(rackitem) {
      this.rackItemForUpdate = rackitem
      this.rackIDForUpdate = this.rackItemForUpdate.value
    },
    SelectedRack(rackitem) {
      this.rackitem = rackitem
      this.rackID = rackitem.value
    },
    SelectedFltRack(fltrackitem) {
      this.fltrackitem = fltrackitem
      this.fltrack = fltrackitem.value
    },
    getBinList() {
      this.isLoadingSearch = true;
      this.BinList = []
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'listBinMaster?limit=' + this.limit + '&offset=' + this.pageNo + '&rackId=' + this.fltrack,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoadingSearch = false;
          if (result.data.ResultCode == 100) {
            this.BinList = result.data.ResponseData;
            this.totalRows=result.data.TotalCount
            if (this.totalRows < 10) {
              this.pageCount = 1
            } else {
              this.pageCount = Math.ceil(this.totalRows / 10);
            }
          } else {
            this.BinList = []
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoadingSearch = false;
          console.error(error)
        })
    },
    addBin() {
      this.binError=0
      this.binErrorMsg=""
      if(this.regexForBinNum.test(this.binNumber) == false)
      {
        this.binError=1;
        this.binErrorMsg="Bin Number Must Be AlphaNumeric";
        return false;
      }
      this.input = ({
        "rackId": this.rackID,
        "binNumber": this.binNumber,
        "createdBy": this.createdby,
      })
			this.isLoading = true;
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'addBin',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            this.resetForm();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },
    updateBin() {
      this.updateError=0
      this.rackIdError=false;
      this.rackIdErrorMsg="";
      this.binNoError=false;
      this.binNoErrorMsg=""
      if(!this.binNumberForUpdate || this.binNumberForUpdate=="")
      {
        this.binNoError=true;
        this.binNoErrorMsg="Enter Bin Number"
        this.updateError=1
      }
      if(!this.rackIDForUpdate || this.rackIDForUpdate=="")
      {
        this.rackIdError=true;
        this.rackIdErrorMsg="Select  Rack Id";
        this.updateError=1
      }

      if(this.binNumberForUpdate && this.regexForBinNum.test(this.binNumberForUpdate) == false)
      {
        this.binNoError=true;
        this.binNoErrorMsg="Bin Number Must Be AlphaNumeric"
        this.updateError=1
      }
      if(this.updateError==1)
      {
        return false;
      }
      this.input = ({
        "binMasterId": this.modaldata.binmasterid,
        "binNumber": this.binNumberForUpdate,
        "rackId": this.rackIDForUpdate,
        "isActive": this.modaldata.isactive,
        "LastModifiedBy": this.createdby
      })
      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + 'updateBin',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            this.closeUpdateBinModal();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          console.error(error)
        })
    },
    resetForm() {
      this.binError=0
      this.binErrorMsg=""
      this.rackitem = {
        value: '',
        text: ''
      }
      this.rackID = ''
      this.binNumber = ''
      this.isLoading = false
      this.$validator.reset()
    },
    resetFlt() {
      this.totalRows=0
      this.fltrackitem = {
        value: '',
        text: ''
      }
      this.fltrackID = ''
      this.isLoadingSearch = false
      this.$validator.reset()
      this.fltrack=''
      this.BinList=[]
      // this.getBinList();
    },
    getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1)
      this.getBinList()
    },
    openUpdateBinModal(data) {
      this.rackItemForUpdate={
        value:data.rackid,
        text:data.rackname
      }
      this.binNumberForUpdate=data.binnumber
      this.rackIDForUpdate=this.rackItemForUpdate.value
      this.updateModal = true
      this.modaldata = data
    },
    closeUpdateBinModal() {
      this.binNumberForUpdate='',
      this.binNoErrorMsg='',
      this.binNoError=false,
      this.rackIdErrorMsg='',
      this.rackIdError=false,
      this.rackIDForUpdate=''
      this.updateModal = false
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
      this.getBinList()
    },
    openStatusModal(data)
    {
      this.statusmodal = true
      this.modalDataForStatus = data
    },
		onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        } else {
          this.addBin();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
		onSubmitFlt: function(Flt) {
      this.$validator.validateAll('Flt').then((result) => {
        if (!result) {
          return false;
        } else {
          this.getBinList();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    closeStatusModal() {
      this.statusmodal = false,
      this.modalDataForStatus=[],
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
      this.getBinList();
    },
    updateBinStatus(){
      var newStatus=this.modalDataForStatus.isactive?0:1;
      this.input = ({
        "binMasterId": this.modalDataForStatus.binmasterid,
        "isActive": newStatus,
        "LastModifiedBy":this.createdby
      })
      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + 'updateBinStatus',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            this.closeStatusModal();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          console.error(error)
        })
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/components/binsMaster/binsMaster.js